import queryString from 'query-string';

import {apiHost} from '../../../report/util';
import {apiClient} from '../../../util/api-client';

async function parseResponse(response) {
  if (response.ok || response.status === 200) {
    return await response.json();
  } else {
    // If there's an error, it can arrive as JSON or as a text string -- try JSON otherwise text.
    const text = await response.text();
    let error;
    try {
      const parsed = JSON.parse(text);
      error = parsed.error;
    } catch (err) {
      error = text;
    }
    throw new Error(error);
  }
}

function getCustomEventUrl({projectId, workspaceId}) {
  return workspaceId
    ? `${apiHost()}/api/app/workspaces/${workspaceId}/custom_events`
    : `${apiHost()}/api/app/custom_events/${projectId}`;
}

export async function saveCustomEvent(customEvent, {projectId, workspaceId}) {
  const {name, alternatives} = customEvent.toSerializedCustomEvent();
  let url = `${getCustomEventUrl({projectId, workspaceId})}/`;
  if (customEvent.id) {
    url = `${url}${customEvent.id}/`;
  }
  // custom events api is not APIResponse compatible
  // eslint-disable-next-line local-rules/deprecated-member-access
  const response = await apiClient.fetch(url, {
    headers: {
      'Content-Type': `application/x-www-form-urlencoded`,
    },
    method: `POST`,
    body: queryString.stringify({
      name,
      alternatives: JSON.stringify(alternatives),
    }),
  });

  return parseResponse(response);
}

export async function deleteCustomEvent(id, {projectId, workspaceId}) {
  const url = `${getCustomEventUrl({projectId, workspaceId})}/${id}`;
  // custom events api is not APIResponse compatible
  // eslint-disable-next-line local-rules/deprecated-member-access
  const response = await apiClient.fetch(url, {
    headers: {
      'Content-Type': `application/x-www-form-urlencoded`,
    },
    method: `DELETE`,
  });

  return parseResponse(response);
}
